/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import logom from "../../assets/user/user/4.jpg";
import { authentification } from '../../services/authentification';
import toast from 'react-hot-toast';
import { toPng } from 'html-to-image';
import QRCode from 'react-qr-code';
const ProfileCompany = () => {
    const navigate = useNavigate();
    const home = () => {
        navigate('/company/dashboad');
    };

    const [userProfile, setUserProfile] = useState([])
    const qrRef = useRef(null)
    const [wait, setWait] = useState(true)
    // get user profile
    useEffect(() => {
        authentification.profileCompany()
            .then((res) => {
                // console.log("userProfileRes ::: ", res.data)
                setUserProfile(res.data)
            })
            .catch((err) => {
                console.log(err)
                if (err.response) {
                    if (err.response.status === 400) {
                        navigate("/auth/loginCompany");
                    }
                    if (err.response.status === 404) {
                        toast.success("Utilisateur introuvable")
                    }
                    if (err.response.status === 500) {
                        toast.error("Erreur d'exécution dans l'application , veillez vous réconnecter.")
                    }
                }
            })
    }, []);

    const idStructure = userProfile.id
    const url = `https://tender-jackson.212-227-211-20.plesk.page/client/logup/${idStructure}`
    // const url = `http://localhost:3000/client/logup/${idStructure}`
    const QrCodeinfo = JSON.stringify({
        url,
    });

    // Function to format the current date and time as 'YYYY-MM-DD_HH-MM'
    const getFormattedDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}_${hours}-${minutes}`;
    };

    // Function to download QR code as image with custom filename
    const downloadQrCode = () => {
        setWait(false)
        if (qrRef.current === null) {
            return;
        }
        // Format the filename as "GuestName-EventName-DateTime.png"
        const dateTime = getFormattedDateTime(); // Get the current date and time
        const filename = `${userProfile.nom}-${dateTime}.png`;

        toPng(qrRef.current)
            .then((dataUrl) => {
                const link = document.createElement('a');
                link.download = filename; // Set the filename dynamically-
                link.href = dataUrl;
                link.click();
                setWait(true);
            })
            .catch((err) => {
                setWait(true)
                console.error('Error generating image', err);
                toast.error("Erreur lors du téléchargement du code qr")
            });
    };



    const date = userProfile.date
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Tableau de bord</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li onClick={home} className="breadcrumb-item link">Acceuil</li>
                                <li className="breadcrumb-item active">Profil</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <section className="col-lg-6">
                            <div className="card bordure ">
                                <div className="card-body">
                                    <div className="tab-content p-0">
                                        <div className="chart tab-pane active" id="revenue-chart" style={{ position: 'relative', height: 390 }}>
                                            <div className="logo text-center  px-2 py-2">
                                                <div className="qr-code-container">
                                                    <QRCode
                                                        className='link qr-code'
                                                        ref={qrRef}
                                                        onClick={downloadQrCode}
                                                        value={QrCodeinfo}
                                                        size={256}
                                                    /> <br />

                                                    {
                                                        wait ?
                                                            <button onClick={downloadQrCode} className="bouton-qr" title='Cliquer pour télécharger le Code QR' >
                                                                Télécharger le QR Code
                                                            </button>
                                                            :
                                                            <button className="bouton-qr"> <span className="spinner-border text-black spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Téléchargement..</button>
                                                    }
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="info d-flex justify-content-between mt-4">
                                                <span><i className="fas fa-user mr-2" />Nom du proprietaire :  </span>
                                                <span className='capitalize'>{userProfile.nomBoss}</span>
                                            </div>
                                            {/* <hr />
                                            <div className="info d-flex justify-content-between mt-4">
                                                <span><i className="fas fa-calendar mr-2" />Date de création :  </span>
                                                <span>{date}</span>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="col-lg-6">
                            <div className="card bordure ">
                                <div className="card-header p-2 ">
                                    <div className="card-title">
                                        <h5 className='title-card  m-0 text-center text-md-left'>
                                            <i class="fa fa-info-circle icon ml-1 mr-2"></i>
                                            Informations générales
                                        </h5>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="tab-content p-0">
                                        <div className="chart tab-pane active" id="revenue-chart" style={{ position: 'relative', height: 360 }}>
                                            <div className="info d-flex justify-content-between mt-4">
                                                <span > <i class="fas fa-user mr-2 "></i>Raison social :  </span>
                                                <span className='capitalize'>{userProfile.nom}</span>
                                            </div>
                                            <hr />
                                            <div className="info d-flex justify-content-between mt-4">
                                                <span> <i className='fas fa-map-marker-alt mr-2'></i>Localisation :  </span>
                                                <span>{userProfile.ville + " , " + userProfile.localisation}</span>
                                            </div>
                                            <hr />
                                            <div className="info d-flex justify-content-between mt-4">
                                                <span><i class="fas fa-phone  mr-2" />Téléphone : </span>
                                                <span>(+237) {userProfile.numeroTel}</span>
                                            </div>
                                            <hr />
                                            <div className="info d-flex justify-content-between mt-4">
                                                <span><i class="fas fa-clipboard  mr-2" />Secteur d'activité :  </span>
                                                <span className=''>{userProfile.Activite}</span>
                                            </div>
                                            <hr />
                                            <div className="info d-flex justify-content-between mt-4">
                                                <span><i class="fas fa-user-circle  mr-2" />Nombre de clients  :  </span>
                                                <span>{userProfile.nbrClient}</span>
                                            </div>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div >
            </section >
        </div >
    );
};

export default ProfileCompany;